module.exports = __webpack_public_path__ + "static/media/login-head.ff1b3509.png";